import { AppThunk } from '../../../../store/types';
import { Navigator } from '../../../../effects/navigator';

export class HeaderEvents {

  public static onClickLogo (): AppThunk {
    return () => {
      Navigator.openRoot();
    }
  }

}
